import { CockpitFilterConfig } from '../models/cockpit-filter-config.model';

export const VN_FILTER_CONFIG: CockpitFilterConfig[] = [
  {
    path: 'vn',
    defaultFilters: [],
    keepFilters: [],
  }
];
